import React from 'react';
import {
  Card,
  Box,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  InputAdornment
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterIcon
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PayrollStatus } from '../../services/payrollService';

interface PayrollFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilter: PayrollStatus | '';
  onStatusFilterChange: (value: PayrollStatus | '') => void;
  dateRange: { start: Date | null; end: Date | null };
  onDateRangeChange: (range: { start: Date | null; end: Date | null }) => void;
  onClearFilters: () => void;
}

const PayrollFilters: React.FC<PayrollFiltersProps> = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  dateRange,
  onDateRangeChange,
  onClearFilters
}) => {
  return (
    <Card sx={{ mb: 3 }}>
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center">
          <TextField
            placeholder="Search by employee name or ID..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ minWidth: 300 }}
          />
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Status Filter</InputLabel>
            <Select
              value={statusFilter}
              label="Status Filter"
              onChange={(e) => onStatusFilterChange(e.target.value as PayrollStatus | '')}
            >
              <MenuItem value="">All Statuses</MenuItem>
              {Object.values(PayrollStatus).map((status) => (
                typeof status === 'number' && (
                  <MenuItem key={status} value={status}>
                    {PayrollStatus[status]}
                  </MenuItem>
                )
              ))}
            </Select>
          </FormControl>
          <DatePicker
            label="Start Date"
            value={dateRange.start}
            onChange={(date: any) => onDateRangeChange({ ...dateRange, start: date })}
            slotProps={{ textField: { sx: { minWidth: 150 } } }}
          />
          <DatePicker
            label="End Date"
            value={dateRange.end}
            onChange={(date: any) => onDateRangeChange({ ...dateRange, end: date })}
            slotProps={{ textField: { sx: { minWidth: 150 } } }}
          />
          <Button
            variant="outlined"
            startIcon={<FilterIcon />}
            onClick={onClearFilters}
          >
            Clear
          </Button>
        </Stack>
      </Box>
    </Card>
  );
};

export default PayrollFilters;
